var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup163393(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_163393",
    "data-name": "Group 163393",
    transform: "translate(-1211 -958)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_9378",
    "data-name": "Ellipse 9378",
    transform: "translate(1211 958)",
    fill: "#fff",
    stroke: "#1b1c1d",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 21,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 20.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "details-svgrepo-com",
    transform: "translate(1221 968)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6373",
    "data-name": "Path 6373",
    d: "M20.333,6H3.222A1.222,1.222,0,0,0,2,7.222V19.444a1.222,1.222,0,0,0,1.222,1.222H20.333a1.222,1.222,0,0,0,1.222-1.222V7.222A1.222,1.222,0,0,0,20.333,6Zm0,13.444H3.222V7.222H20.333Z",
    transform: "translate(-0.778 -2.333)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6374",
    "data-name": "Path 6374",
    d: "M8.611,13.222h11a.611.611,0,0,0,0-1.222h-11a.611.611,0,0,0,0,1.222Z",
    transform: "translate(-3.111 -4.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6375",
    "data-name": "Path 6375",
    d: "M8.611,17.222h11a.611.611,0,0,0,0-1.222h-11a.611.611,0,0,0,0,1.222Z",
    transform: "translate(-3.111 -6.222)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6376",
    "data-name": "Path 6376",
    d: "M8.611,21.222h6.111a.611.611,0,1,0,0-1.222H8.611a.611.611,0,0,0,0,1.222Z",
    transform: "translate(-3.111 -7.778)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_148283",
    "data-name": "Rectangle 148283",
    width: 22,
    height: 22,
    fill: "rgba(0,0,0,0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup163393);
export default __webpack_public_path__ + "static/media/Group 163393.fdc92dc27126a0efc7a102bef87a3bab.svg";
export { ForwardRef as ReactComponent };